import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Text } from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';
import { Switch } from '@redlink/components/molecules';

export const BodyBlockContainer = memo(
  ({
    children,
    title,
    isProUser,
    selectedPeriodTypeKey,
    onChangePeriodTypeKey,
  }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();

    const switchData = useMemo(
      () => [
        {
          key: 'last24Hours',
          value: dictionary.last24Hours,
          disabled: false,
        },
        {
          key: 'last7Days',
          value: dictionary.last7Days,
          disabled: false,
        },
        {
          key: 'lastMonth',
          value: dictionary.lastMonth,
          disabled: !isProUser,
        },
        {
          key: null,
          value: dictionary.totalOf,
          disabled: !isProUser,
        },
      ],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [isProUser]
    );

    const selectedItem = switchData.find(
      ({ key }) => key === selectedPeriodTypeKey
    );

    return (
      <View>
        <Space size={8} />
        <Text style={styles.titleText}>{title}</Text>
        <Space />
        <Switch
          activeThumbColor="white"
          thumbColor="white"
          data={switchData}
          selected={selectedItem}
          onChange={(item, index) => onChangePeriodTypeKey(item.key)}
        />
        <Space size={20} />
        {children}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  titleText: {
    color: colors.black,
    fontSize: 14,
  },
}));
